import { Box, Stack, Typography } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

export const ListenModalContent: FC = () => {
  const { t } = useTranslation();
  return (
    <Stack direction="column" spacing={2}>
      <Box sx={(theme) => ({ height: 250, bgcolor: theme.palette.background.paper })}>
        <iframe
          src="https://media.changeengine.com/v/5f0111e3-4d48-434d-9078-4ed685f6b112"
          title="video"
          width="100%"
          height="100%"
          allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
          allowFullScreen
          style={{ border: "none" }}
        />
      </Box>
      <Typography variant="body2">
        Feedback tools aren’t the problem. Disconnected ones are.
      </Typography>
      <Typography variant="body2">
        {t(
          "Most teams juggle 2 - 3 feedback platforms that frontline employees never use - and even when responses roll in, the data’s stale before anyone can act.",
        )}
      </Typography>
      <Typography variant="body2" fontWeight={700}>
        Meet Listen: ChangeEngine’s built-in feedback engine that closes the loop.
      </Typography>
      <Typography variant="body2">
        {t(
          "Send mobile-first surveys, embed polls in your Communications, trigger manager nudges, and access real-time insights - all from the same dashboard you use to communicate. From pulse polls to onboarding check-ins, Listen turns feedback into action plans, not PDFs collecting dust.",
        )}
      </Typography>
      <Typography variant="body2">
        Consolidate spend. Reach more employees. Drive faster decisions.
      </Typography>
      <Typography variant="body2" fontWeight={700}>
        Ready to hear what matters most?
      </Typography>
    </Stack>
  );
};
